module.exports = __webpack_public_path__ + "img/full.da7e415b.png";